const AccountState = {
    accountDetails: {},
    groups: [],
    account: {},
    settings: [],
    subordinates: [],
    profit: 0
};

export default AccountState;